<template>
    <!--
            作者：kmdshop
            时间：2020-04-20
            描述：修改价格
        -->
    <el-dialog title="服务项目" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="70%"
               :append-to-body="true">
        <!--内容-->
    <div class="product-content">
        <div class="table-wrap" style="margin-top: 15px;" >
            <el-table size="small" :data="tableData" border style="width: 100%">
              <el-table-column prop="product_name" label="序号" >
                <template slot-scope="scope">
                  <div class="product-info">
                    {{ scope.$index +1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="product_no" label="服务项目" width="200">
                <template slot-scope="scope">
                  <div class="product-info">
                    {{ scope.row.service.name? scope.row.service.name:"" }}
                  </div>
                </template>

              
              </el-table-column>
              <el-table-column prop="opuser.nickName" label="前端最后编辑人员"></el-table-column>
            <el-table-column  label="后端最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                </div>
              </template>

            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>
              <el-table-column prop="product_weight" label="操作" >
                <template slot-scope="scope" >
                  <div class="d-b-c">
                    <el-button  @click="addRemark(scope.row.order_service_id)" type="text" size="small" >项目备注</el-button>
                  </div>
               </template>
              </el-table-column>
       
            </el-table>
          </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
        </div>
          <ServiceRemark :open_edit="is_service_remark" :order_service_id="order_service_id" v-if="is_service_remark" @close="closeServiceFunc"></ServiceRemark>
 
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
     import ServiceRemark from './../service/index.vue'
    export default {
        components:{
            ServiceRemark
        },
        data() {
            return {
                 /*当前是第几页*/
                curPage: 1,
                /*一页多少条*/
                pageSize: 15,
                /*一共多少条数据*/
                totalDataNumber: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                order: {
                    update_price: 0,
                    update_express_price: 0.00,
                },
                tableData:[],
                is_service_remark:false,
                order_service_id:0
            };
        },
        props: {
            // 开启弹窗
            open_edit: Boolean,
            order_id:Number,
            // 是否多选
            multi: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        },
        created() {
            console.log(" this.order_id", this.order_id)
            this.getData();
        },
        methods: {
            addRemark(order_service_id){
                this.order_service_id = order_service_id;
                this.is_service_remark = true;
            
            },
             /*选择第几页*/
            handleCurrentChange(val) {
            this.curPage = val;
            this.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getTableList();
            },
//            获取数据
            getData(){
                let self = this;
                OrderApi.getOrderService({
                    order_id:self.order_id,
                    page:self.curPage,
                    list_rows: self.pageSize,
                }, true).then(data =>
                {
                    self.loading = false;
                    self.tableData = data.data.list.data;
                    self.totalDataNumber = data.data.list.total;
                }).catch(error =>
                {
                    self.loading = false;
                });
            },
             /*选择用户*/
            handleSelectionChange(e) {
                this.multipleSelection = e;
            },
          
            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            },
            closeServiceFunc(e){
                if (e.type != 'error') {
        
                this.getData();
                }
                this.is_service = false
                this.is_service_remark = false
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/service.vue